import React from 'react';
import PropTypes from 'prop-types';

import { Navigate } from 'react-router-dom';

const CheckNotLogin = ({ children }) => {
    if (window.localStorage.getItem('jwt')) {
        return <Navigate replace to="/" />;
    }

    return children;
};

CheckNotLogin.propTypes = {
    children: PropTypes.node,
};

export default CheckNotLogin;
